<template>
  <div class="js_slider line">
    <div class="js_frame">
      <ul class="js_slides">
        <li class="js_slide">
            <div class="con" :style="{ backgroundImage: 'url(' + pic + ')' }">
              <img :src="pic" :alt="$props.park.description" />
              <a class="link" :href="$props.park.url">View park</a>
            </div>
        </li>
        <propCard
          v-for="property in $props.properties"
          :key="property.id"
          :property="property"
          :clName="'js_slide'"
          :date="''"
          :nights="''"
          :card="'card lodge'"
        />
      </ul>
      <div class="cover" @click.stop="goToPark"></div>
    </div>
    <div class="prev" @click.stop="goPrev">
      <svg class="ico">
        <use xlink:href="#ico-arr"></use>
      </svg>
    </div>
    <div class="next" @click.stop="goNext">
      <svg class="ico">
        <use xlink:href="#ico-arr"></use>
      </svg>
    </div>
  </div>
</template>

<script>
import propCard from 'shared/card.vue'

export default {
    data: function () {
        return {
            pic: this.$props.park.images && this.$props.park.images.length > 0 ? this.$props.park.images[0].url : ''
        }
    },
    props: {
        park: Object,
        properties: Array
    },
    watch: {
        '$props.properties': function(newV, oldV) {
            let app = this;
            if (newV.length > 0) {
                app.loadCaro();
            }
        }
    },
    methods: {
        goToPark() {
            window.location.href = this.$props.park.url;
        },
        goNext(e) {
            e.currentTarget.parentNode.slide.next();
        },
        goPrev(e) {
            e.currentTarget.parentNode.slide.prev();
        },
        setup() {
            let el = this.$el;
            setTimeout(function() {
                el.slide = new window.lory(el, {
                    rewind: true
                });
            }, 1000);
        },
        loadCaro() {
            let app = this;
            if (document.body.clientWidth > 1023 && app.$props.properties.length > 2) {
                app.setup();
            } else {
                app.$el.classList.add("no-ctrls");
            }
        }
    },
    components: {
        propCard
    }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.js_slider {
  width: 100%;
}

.cover {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 9;
  top: 0;
  left: 0;
  cursor: pointer;
}

.js_slider,
.js_frame,
.js_slide {
  position: relative;
}

.js_frame {
  font-size: 0;
  line-height: 0;
  overflow: hidden;
  white-space: nowrap;
}

.js_slides {
  display: block;
  margin-top: 1.25rem;
}

.js_slide {
  width: 100%;
  max-width: 26.25rem;
  margin: 0 auto 1.25rem;
  padding: .313rem;

  &:first-child {
    padding: .313rem .313rem .313rem 0;
  }
}

li {
  height: auto;
  overflow: auto;
  position: relative;
  z-index: 1;
  cursor: pointer;
  margin: .625rem 0;

  &:hover h2 {
    text-decoration: underline;
  }
}

.next, .prev {
  display: none;
}

ul {
  list-style: none;
}

.link {
  bottom: 1rem;
  font-size: .75rem;
  font-weight: 700;
  text-transform: uppercase;
  height: 2.188rem;
  position: absolute;
  z-index: 9;
  padding: 0 1.25rem;
  right: 1rem;
  background: $col_white;
  border-radius: .25rem;
  box-sizing: border-box;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.2);
  cursor: pointer;
  outline: none;
  text-align: center;
  line-height: 2.188rem;
  text-decoration: none;

  &:focus {
    box-shadow: 0 0.125rem 1.25rem 0 $col_aqua;
  }
}

.con {
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 24.75rem;
  width: 100%;
  box-shadow: 0 .125rem .25rem $col_oplightblack;
  
  img {
    width: 100%;
    opacity: 0;
  }
}

@media #{$desktop} {
  .js_slide {
    width: calc(100% / 3);
    margin: 0 0 0.313rem 0;
    padding: .625rem;
    box-sizing: border-box;

    &:first-child {
      padding: .625rem .625rem .625rem 0;
    }
  }

  .js_slides,
  .js_slide {
    display: inline-block;
  }

  .js_slides {
    width: 100%;
  }

  .con {
    h2 {
      font-size: 2.125rem;
    }
  }

  .next,
  .prev {
    position: absolute;
    display: block;
    cursor: pointer;
    top: 50%;
    z-index: 10;
    opacity: 0;
    user-select: none;
    margin-top: -1.25rem;

    .no-ctrls & {
      display: none;
    }

    .ico {
      fill: $col_white;
      width: 2.813rem;
      height: 2.813rem;
      filter: drop-shadow(0 0.125rem 0.125rem $col_quartopacity);
    }

    .line:hover & {
      opacity: 1;
    }
  }

  .next {
    right: 1.25rem;
  }

  .prev {
    left: 1.25rem;

    .ico {
      transform: rotate(180deg);
    }
  }
}

</style>